import { css } from "@emotion/css";
import { ActionButtonType } from "@octopusdeploy/design-system-components";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import { OctoLink } from "@octopusdeploy/utilities";
import * as React from "react";
import { Action, Plan, useAnalyticActionDispatch } from "~/analytics/Analytics";
import { AuditActionWithStatus } from "~/areas/configuration/components/AuditLayout/AuditStream/AuditActionWithStatus";
import { AuditStreamUpsellDialog } from "~/areas/configuration/components/AuditLayout/AuditStream/AuditStreamUpsellDialog";
import { repository } from "~/clientInstance";
import OpenDialogButton from "~/components/Dialog/OpenDialogButton";
import { isFeatureToggleEnabled } from "~/components/FeatureToggle/New/FeatureToggleContext";
import { RequestFeatureTrialUpsellDialog } from "~/components/UpsellDialog/RequestFeatureTrialUpsellDialog";
import { UpsellAuditStreamIllustration } from "~/components/UpsellDialog/UpsellAuditStreamIllustration";
export function AuditStreamUpsellButton() {
    const dispatchAction = useAnalyticActionDispatch();
    const isFreeTierEnabled = isFeatureToggleEnabled("free-tier");
    const handleClick = () => {
        dispatchAction("Stream Audit Log", { resource: "Audit Stream", action: Action.Add, plan: Plan.NonEnterprise });
    };
    if (isFreeTierEnabled) {
        return (<RequestFeatureTrialUpsellDialog featureName={"Audit Stream"} buttonTitle="Stream Audit Log" upsellDialogTitle="Stream audit events to your SIEM for faster detection and easier audits" docsLabel="Docs: Audit Stream" docsLink={OctoLink.Create("AuditStream")} requestTrialDialogTitle="Request a free trial of Audit Stream" onRequestTrial={async () => {
                await repository.AuditStreamConfiguration.requestTrial();
            }} upsellDialogSidePanelImage={<UpsellAuditStreamIllustration />}>
                <div className={styles.dialogContent}>
                    <p>
                        Audit logs are most helpful when they’re part of your security workflows. Streaming audit events to Splunk, Sumo Logic, or any OTLP-compatible SIEM helps you catch issues early and demonstrate compliance with less manual
                        effort.
                    </p>
                    <p>Available on the Enterprise tier.</p>
                </div>
            </RequestFeatureTrialUpsellDialog>);
    }
    return (<AuditActionWithStatus status={"inactive"}>
            <OpenDialogButton type={ActionButtonType.Ternary} label="Stream Audit Log" dialogWidth={"1000px"} onClick={handleClick} renderDialog={(renderProps) => <AuditStreamUpsellDialog open={renderProps.open} close={() => renderProps.closeDialog()}/>}/>
        </AuditActionWithStatus>);
}
const styles = {
    dialogContent: css({
        display: "flex",
        flexDirection: "column",
        font: text.body.regular.large,
        gap: space[16],
        "& p": {
            margin: 0,
            color: themeTokens.color.text.primary,
        },
    }),
};
